// extracted by mini-css-extract-plugin
module.exports = {"dropdownToggle":"DropdownToggle_dropdownToggle__2M3R4","black":"DropdownToggle_black__19Brz"};